import { render, staticRenderFns } from "./ViewStakeholderModal.vue?vue&type=template&id=6ef9d0e5"
import script from "./ViewStakeholderModal.vue?vue&type=script&lang=js"
export * from "./ViewStakeholderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ef9d0e5')) {
      api.createRecord('6ef9d0e5', component.options)
    } else {
      api.reload('6ef9d0e5', component.options)
    }
    module.hot.accept("./ViewStakeholderModal.vue?vue&type=template&id=6ef9d0e5", function () {
      api.rerender('6ef9d0e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/ViewStakeholderModal.vue"
export default component.exports